const formTrackingDataLayer = function (formData, isMultiStep = false) {
    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    const values = JSON.parse(htmlDecode(unescape(decodeURI(formData.replaceAll('+',' ')))));
    values.formPageUrl = (values.formPageUrl && values.formPageUrl !== null && values.formPageUrl !== "") ? values.formPageUrl : window.location.pathname;
    if (window.isNonProd){
        console.log('----------------------------- \n' +
        'DataLayer Event Triggered: \nform.submit');
        Object.keys(values).forEach((key) => {
            console.log("    "+key+": "+values[key]);
        });
        console.log("    isMultiStep: "+ isMultiStep);
        console.log(values);
        console.log('----------------------------- \n');
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'form.submit', 
        formId: values.formId,
        formName: values.formName,
        formPageUrl: values.formPageUrl,
        isMultiStep: isMultiStep,
        formData: values,
    }); 
};

const formTrackingPageDataLayer = function (stepNum, formId) {

    if (window.isNonProd){
        console.log('----------------------------- \n' +
        'DataLayer Event Triggered: \nform.step');
        console.log("    step: "+ stepNum);
        console.log("    isMultiStep: "+ true);
        console.log('----------------------------- \n');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'form.step',
        formId: formId,
        isMultiStep: true, 
        step: stepNum
    });
};

export {formTrackingDataLayer, formTrackingPageDataLayer};